import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

/// Os mesmos números do EWebhookEvent no servidor.
export enum EWebhookEvent {
    LeadCreated = 0,
    LeadMoved = 1,
    LeadWon = 2,
    LeadLost = 3,
    LeadAssigned = 4,
}

/// Mesmos números do EWebhookFormat: Json vai a sistema (assinado), os outros a chat.
export enum EWebhookFormat {
    Json = 0,
    Slack = 1,
    Discord = 2,
    Teams = 3,
}

export const isChatFormat = (format: EWebhookFormat) => format !== EWebhookFormat.Json;

export interface WebhookSubscription {
    id: string;
    name: string;
    url: string;
    events: number[];
    active: boolean;
    /// Só os quatro últimos caracteres; o segredo inteiro não volta após criado.
    secretHint: string;
    lastAttemptAt?: string | null;
    lastStatusCode?: number | null;
    lastError?: string | null;
    format: EWebhookFormat;
}

export interface SaveWebhookRequest {
    name: string;
    url: string;
    events: number[];
    active: boolean;
    format: EWebhookFormat;
    /// Vazio na edição mantém o segredo atual.
    secret?: string | null;
}

export class WebhookService extends BaseService {
    protected resourceName = 'crm/webhooks';

    public async list(): Promise<AxiosResponse<{ data: WebhookSubscription[] }>> {
        return await this.get('');
    }

    public async create(
        body: SaveWebhookRequest
    ): Promise<AxiosResponse<{ data: WebhookSubscription }>> {
        return await this.post(body, '');
    }

    public async update(
        id: string,
        body: SaveWebhookRequest
    ): Promise<AxiosResponse<{ data: WebhookSubscription }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
